import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import { useSeoProfiles } from "../context/SeoContext";
import { MaskedLines } from "./motion/Reveal";

export const PageHeader = ({ pageKey, overline, title, sub, image, mobileImage, compact = false, overrideProfile = false }) => {
  const { lang } = useLang();
  const { profiles } = useSeoProfiles();
  const profile = pageKey ? profiles[pageKey] : null;
  const resolvedOverline = overrideProfile ? (overline || profile?.overline?.[lang]) : (profile?.overline?.[lang] || overline);
  const resolvedTitle = overrideProfile ? (title || profile?.h1?.[lang]) : (profile?.h1?.[lang] || title);
  const resolvedSub = overrideProfile ? (sub || profile?.subtitle?.[lang]) : (profile?.subtitle?.[lang] || sub);
  return (
    <section className={`relative overflow-hidden grain bg-charcoal mt-[76px] sm:mt-[92px] ${compact ? "pt-12 pb-10 sm:pt-16 sm:pb-14" : "pt-20 pb-20 sm:pt-28 sm:pb-28"}`} data-testid="page-header">
      {image && (
        <>
          <motion.picture initial={{ scale: 1.15 }} animate={{ scale: 1 }} transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }} className="absolute inset-0 w-full h-full">
            {mobileImage && <source media="(max-width: 767px)" srcSet={mobileImage} />}
            <img src={image} alt={resolvedTitle} className="w-full h-full object-cover" />
          </motion.picture>
          <div className="absolute inset-0 bg-charcoal/70" />
          <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/30 to-transparent" />
        </>
      )}
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8">
        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }} className="overline">
          {resolvedOverline}
        </motion.span>
        <h1 className={`font-display text-white tracking-tight mt-4 leading-[0.98] max-w-4xl ${compact ? "text-3xl sm:text-4xl lg:text-5xl" : "text-4xl sm:text-6xl lg:text-7xl"}`}>
          <MaskedLines lines={[resolvedTitle]} delayBase={0.2} />
        </h1>
        {resolvedSub && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.7 }}
            className={`text-white/75 max-w-2xl leading-relaxed ${compact ? "text-sm sm:text-base mt-3" : "text-base sm:text-lg mt-6"}`}
          >
            {resolvedSub}
          </motion.p>
        )}
      </div>
    </section>
  );
};
